import { useDispatch } from 'react-redux';
import { openConfirm } from '../store/confirmSlice';

export default function useConfirm() {
  const dispatch = useDispatch();
  return ({ title, message }) =>
    new Promise(resolve => {
      dispatch(openConfirm({
        options: { title, message },
        resolver: resolve
      }));
    });
}